import { X } from "lucide-react";

const NotificationPopup = ({ onClose }) => {

  return (
    <div className="fixed inset-0 theme-background flex z-[2] flex-col items-center p-12">
      <h2 className="text-3xl font-bold mt-6 mb-4">Notifications</h2>
      <div>
        <span>No notifications</span>
      </div>
      <button className="absolute top-6 right-6" onClick={onClose}>
        <X size={50} />
      </button>
    </div>
  );
};

export default NotificationPopup;
